'use client'

// The tube carriage in the north-east corner, his fifth roost. Sam's
// model, 30 Oct: a London Underground car with one double door taken off
// the side that faces the town, and two pallets off the junk heap stacked
// under the gap for a step, laid out in Blender AT WORLD COORDINATES, so
// it renders at identity like the taco truck.
//
// He sleeps inside it: the rest_5 roost (lib/world/modelPois.js) is on
// the floor of the vestibule across from the open door. The floor is a
// metre up, so what he and a visitor stand on in there is
// WALK_carriage_floor and WALK_carriage_step in obstacles.glb, and the
// walls, the seats and the shut cab are the obs_carriage_ boxes beside
// them. Moving the carriage means moving it in Blender and re-exporting
// all three (this, obstacles.glb, and the roost through wants-sync.py).

import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/carriage.glb'

export function Carriage() {
  const { scene } = useModel(MODEL)

  useSceneNodeMaterials(scene, { roughness: 0.9 })

  // Baked transform: render at identity.
  return <primitive object={scene} />
}

export default Carriage
